import { render, staticRenderFns } from "./subFranchise.vue?vue&type=template&id=2003e497&scoped=true&"
import script from "./subFranchise.vue?vue&type=script&lang=js&"
export * from "./subFranchise.vue?vue&type=script&lang=js&"
import style0 from "./subFranchise.vue?vue&type=style&index=0&id=2003e497&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003e497",
  null
  
)

export default component.exports